<div class="lab-navbar-header">
  <div class="lab-navbar-header-logo"></div>
  <div class="lab-navbar-header-toggle">
    <button class="lab-navbar-icon-button" aria-label="Hide navigation" (click)="onNavbarHide($event)">
      <lab-icon [name]="SolIcon.sidebar_left" />
    </button>
  </div>
</div>
@if (appsVisible$()) {
  <div class="lab-navbar-app-container">
    @if (appsDropdownVisible$()) {
      <button
        type="button"
        class="lab-navbar-app"
        [class.lab-navbar-app-selected]="appHover$()"
        (click)="onAppClick($event)"
      >
        <lab-icon [name]="appDisplayIcon$() ?? SolIcon.application" />
        <div class="lab-navbar-app-name">{{ appDisplayName$() | translate }}</div>
        <lab-icon [name]="SolIcon.chevrons_vertical" size="20" />
      </button>
    } @else {
      <div class="lab-navbar-app lab-navbar-app-readonly">
        <lab-icon [name]="appDisplayIcon$() ?? SolIcon.application" />
        <div class="lab-navbar-app-name">{{ appDisplayName$() | translate }}</div>
      </div>
    }
  </div>
}
<div class="lab-navbar-menu-scroll-container">
  <div class="lab-navbar-menu-scroll-content">
    @if (loading$()) {
      <lab-loader [loader]="SolLoader.ofList(6, 1).withMargin('0')" />
    } @else {
      <!-- items -->
      @for (item of menu$(); track item.id) {
        @if (item.hasAuthority) {
          <lab-navbar-item
            [item]="item"
            [level]="0"
            [activeRouteIds]="activeRouteIds$()"
            [expandedIds]="expandedIds$()"
            (expandedChange)="onExpanded($event)"
          />
        }
      }
    }
  </div>
</div>
<div class="lab-navbar-footer">
  <div class="lab-navbar-footer-buttons">
    @for (item of system$(); track item.id) {
      @if (item.hasAuthority) {
        <button
          class="lab-navbar-icon-button"
          [class.lab-navbar-icon-button-selected]="activeRouteIds$().includes(item.id)"
          [attr.aria-label]="item.displayName || item.id | translate"
          (click)="onSystemClick(item.id, $event)"
          (auxclick)="onSystemClick(item.id, $event, true)"
        >
          <lab-icon [name]="item.icon" />
        </button>
      }
    }
  </div>
  <div class="lab-navbar-footer-account">
    <button class="lab-button-menu-account" (click)="onAccountClick($event)">
      <lab-avatar class="lab-button-menu-account-avatar" [name]="nameText$()" size="small" />
      <div class="lab-button-menu-account-name">{{ nameText$() | translate }}</div>
      <div class="lab-button-menu-account-icon">
        <lab-icon [name]="SolIcon.chevrons_vertical" size="20" />
      </div>
    </button>
  </div>
</div>
